export const CircleExclamationSolid = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12,21.98c5.53,0,10.01-4.48,10.01-10.01S17.53,1.96,12,1.96,1.99,6.44,1.99,11.97s4.48,10.01,10.01,10.01Zm0-15.01c.52,0,.94,.42,.94,.94v4.38c0,.52-.42,.94-.94,.94s-.94-.42-.94-.94V7.91c0-.52,.42-.94,.94-.94Zm1.25,8.76c0,.69-.56,1.25-1.25,1.25s-1.25-.56-1.25-1.25,.56-1.25,1.25-1.25,1.25,.56,1.25,1.25Z" />
    </svg>
  );
};
